import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";

// define a generatePDF function that accepts a tickets argument
const generatePDF = paymentReport => {
var doc = new jsPDF('l', 'mm', 'a4');
var d =      format(new Date(), "yyyy-MM-dd")
;
  // define the columns we want and their titles
  const tableColumn = ["Agency Name", "Email", "Type of License", "Payment Type", "Payment Status","Payment Date","Total Amount" ];
  // define an empty array of rows
  const tableRows = [];

  // for each report pass all its data into an array
  paymentReport.forEach(report => {
    const ticketData = [
      report.agencyName,
      report.agencyEmail,
      report.typeofLicense,
      report.paymentType,
      report.paymentStatus,
      report.paymentDate,
      report.totalAmount,

      // called date-fns to format the date on the report
    ];
    // push each tickcet's info into a row
    tableRows.push(ticketData);
  });


  // startY is basically margin-top
  doc.autoTable(tableColumn, tableRows, { startY: 20 });
  // we use a date string to generate our filename.
  // report title. and margin-top + margin-left
  doc.text("Payment Report_"+d, 14, 15);
  // we define the name of our PDF file.
  doc.save(`payment_report_${d}.pdf`);
};

export default generatePDF;